import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  PasswordInput,
  required,
  email,
  minLength,
  useRecordContext,
} from "react-admin";

function UserTitle() {
  const record = useRecordContext();
  return <span>Utente: {record ? record.email : ""}</span>;
}

export function UserEdit() {
  return (
    <Edit title={<UserTitle />}>
      <SimpleForm>
        <TextInput source="id" label="ID" disabled fullWidth />
        <TextInput
          source="email"
          label="Email"
          validate={[required(), email()]}
          fullWidth
        />
        <PasswordInput
          source="password"
          label="Nuova password"
          helperText="Lascia vuoto per mantenere la password attuale"
          validate={[minLength(8)]}
          fullWidth
        />
        <SelectInput
          source="role"
          label="Ruolo"
          validate={[required()]}
          choices={[
            { id: "admin", name: "Amministratore" },
            { id: "viewer", name: "Utente" },
          ]}
          fullWidth
        />
      </SimpleForm>
    </Edit>
  );
}
